import { Autocomplete } from '@mui/lab';
import FormControl from '@mui/material/FormControl';
import { makeStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import styles from 'assets/jss/material-dashboard-pro-react/components/customInputStyle.js';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { secondaryColor } from '../../themes/defaultThemeProps';

const useStyles = makeStyles({
  ...styles,
  labelFloat: {
    color: 'gray',
    fontSize: '14px',
    '&.Mui-focused': {
      color: secondaryColor[3] + '!important',
    },
    '&.Mui-error': {
      color: 'red',
    },
  },
  autocomplete: {
    '& button': {
      padding: 0,
    },
  },
});

export default function CustomAutocomplete(props) {
  const classes = useStyles();
  const {
    formControlProps,
    labelText,
    id,
    labelProps,
    error,
    white,
    inputRootCustomClasses,
    success,
    helperText,
    options,
    value,
    onChange,
    onInputChange,
    onKeyUp,
    renderOption,
  } = props;

  const labelClasses = classNames({
    [' ' + classes.labelRootError]: error,
    [' ' + classes.labelRootSuccess]: success && !error,
  });

  const marginTop = classNames({
    [inputRootCustomClasses]: inputRootCustomClasses !== undefined,
  });

  const formControlClasses = classNames(
    formControlProps?.className,
    classes.formControl,
    classes.fullWidth
  );

  return (
    (<FormControl
      variant="standard"
      style={{ marginTop: '-25px' }}
      {...formControlProps}
      className={formControlClasses}
      fullWidth>
      <Autocomplete
        id={id}
        className={classes.autocomplete}
        options={options}
        value={value}
        onChange={onChange}
        getOptionLabel={(option) => option.label}
        renderOption={renderOption}
        clearOnEscape={false}
        disableClearable
        fullWidth
        onInputChange={onInputChange}
        renderInput={(params) => (
          <TextField
            {...params}
            label={labelText}
            variant='standard'
            InputProps={{
              ...params.InputProps,
              classes: {
                root: marginTop,
                underline: classes.underline,
              },
              endAdornment: (
                <div style={{ marginRight: '18px' }}>
                  {params.InputProps.endAdornment}
                </div>
              ),
              onKeyUp: onKeyUp,
            }}
            InputLabelProps={{
              shrink: Boolean(value) || params.InputProps?.startAdornment,
              className: classes.labelFloat,
            }}
            error={!!error}
            helperText={!!error ? helperText : null}
            fullWidth
          />
        )}
      />
    </FormControl>)
  );
}

CustomAutocomplete.propTypes = {
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  formControlProps: PropTypes.object,
  inputRootCustomClasses: PropTypes.string,
  error: PropTypes.bool,
  success: PropTypes.bool,
  white: PropTypes.bool,
  helperText: PropTypes.node,
  options: PropTypes.array.isRequired,
  value: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onInputChange: PropTypes.func,
  onKeyUp: PropTypes.func,
  renderOption: PropTypes.func,
};
